export default "__VITE_ASSET__9455479b__"